import { PROYECT, api_get, api_post, api_put } from "services/api";

import { APARTMENTS_TYPES } from "redux/reducers/buildings/apartments/apartmentsTypes";

import {
  startRequestComp,
  stopRequestComp,
  setSnackbar
} from "redux/actions/search/searchActions";

const {
  SET_APARTMENTS,
  NEW_APARTMENT,
  SET_UPSERT_APARTMENT,
  EDIT_APARTMENT,
  ASSIGN_METER,
  ASSIGN_CUSTOMER,
  ASSIGN_CONTRACT,
  SELECTED_METER,
  SEARCH_CUSTOMERS,
  CLEAR_APARTMENTS,
  HANDLE_APARTMENTS_INPUTS,
} = APARTMENTS_TYPES;

const urlApartments = `${process.env.REACT_APP_URL}${PROYECT}/buildings/apartments`;
const urlMeters = `${process.env.REACT_APP_URL}${PROYECT}/buildings/meters`;
const urlCustomers = `${process.env.REACT_APP_URL}${PROYECT}/customers/search`;
const urlConfig = `${process.env.REACT_APP_URL}${PROYECT}/buildings/configurations`;

export function clearApartments() {
  return {
    type: CLEAR_APARTMENTS
  };
}

export function newApartment() {
  return {
    type: NEW_APARTMENT
  };
}

export function editApartment(id) {
  return {
    type: EDIT_APARTMENT,
    payload: id
  };
}

export function assignMeter(id) {
  return {
    type: ASSIGN_METER,
    payload: id
  };
}

export function assignCustomer(id) {
  return {
    type: ASSIGN_CUSTOMER,
    payload: id
  };
}
export function assignContract(id) {
  return {
    type: ASSIGN_CONTRACT,
    payload: id
  };
}

export function removeAssignedMeter(id) {
  return {
    type: SELECTED_METER,
    payload: id
  };
}

export const handleApartmentsInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_APARTMENTS_INPUTS, payload: { key, value } });
};

export const fetchApartments = (idStation = null) => async dispatch => {
  dispatch(startRequestComp("fetchApartments"));
  try {
    const [apartments, meters, config] = await Promise.all([
      api_get(`${urlApartments}?stations=${idStation}`),
      api_get(`${urlMeters}?stations=${idStation}&status=ACTIVO`),
      api_get(urlConfig)
    ]);

    dispatch({
      type: SET_APARTMENTS,
      payload: {
        idStation,
        apartments,
        meters,
        statuses: config.apartmentStatuses,
        businesses: config.apartmentBusinesses
      }
    });

    dispatch(stopRequestComp("fetchApartments"));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchApartments"));
  }
};

export const fetchCustomers = (idStation, phone) => async dispatch => {
  dispatch(startRequestComp("fetchCustomers"));
  try {
    const [customers] = await Promise.all([
      api_get(`${urlCustomers}?stations=${idStation}&phone=${phone}`)
    ]);

    dispatch({
      type: SEARCH_CUSTOMERS,
      payload: customers
    });

    dispatch(stopRequestComp("fetchCustomers"));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchCustomers"));
  }
};

export const fetchNewApartment = body => async dispatch => {
  dispatch(startRequestComp("fetchNewApartment"));
  try {
    const response = await api_post(urlApartments, body);

    dispatch({
      type: SET_UPSERT_APARTMENT,
      payload: response
    });

    dispatch(stopRequestComp("fetchNewApartment"));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchNewApartment"));
  }
};

export const updateApartmentStatus = (id, status, callback) => async dispatch => {
  dispatch(startRequestComp("editApartmentStatus"));
  try {
    const response = await api_put(`${urlApartments}/${id}`, { status });

    dispatch({
      type: SET_UPSERT_APARTMENT,
      payload: response
    });

    if (callback) {
      callback()
    }

    dispatch(stopRequestComp("editApartmentStatus"));
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("editApartmentStatus"));
  }
}

export const fetchEditApartment = (body, id) => async dispatch => {
  dispatch(startRequestComp("fetchEditApartment"));
  try {
    const response = await api_put(`${urlApartments}/${id}`, body);

    dispatch({
      type: SET_UPSERT_APARTMENT,
      payload: response
    });

    dispatch(stopRequestComp("fetchEditApartment"));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp("fetchEditApartment"));
  }
};
